<template>
  <div class="image-area-dialog">
    <el-dialog
      :visible.sync="dialogVisible"
      @change="dialogVisible = false"
      fullscreen
      append-to-body
      custom-class="dialog-image-area"
    >
      <ImageArea
        :value="value"
        @change="handleChange"
        v-if="dialogVisible"
      />
    </el-dialog>
  </div>
</template>

<script>
  import { Vue, Component, Prop } from 'vue-property-decorator';
  import ImageArea from './image-area';

  const defaultValue = {
    containerWidth: 750,
    areas: []
  }

  @Component({
    components: {
      ImageArea,
    }
  })
  export default class ImageAreaDialog extends Vue {
    @Prop({ type: Object, default: () => defaultValue }) value;
    @Prop({ type: Boolean, default: () => false }) dialogVisible;

    handleChange($event) {
      this.$emit('change', $event);
      this.dialogVisible = false;
    }
  }
</script>
